import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities';

import { Button, Modal } from '@salesforce/design-system-react';

import './ExperimentModal.scss';

class ArchiveExperimentModal extends Component {
  constructor(props) {
    super(props);
    this.modalName = 'archiveExperiment';
  }

  getI18nID(suffix) {
    return `components.experiment.archiveModal.${suffix}`;
  }

  isArchived() {
    return this.props.modals.archiveExperiment?.data?.archived;
  }

  // ===================================
  // =         Event Handlers          =
  // ===================================
  handleArchive() {
    this.props.actions.archiveExperiment(
      this.props.modals.archiveExperiment.data,
      this.props.context,
      { cToken: this.props.session.experimentCsrfToken }
    );
    this.closeModal();
  }

  handleUnarchive() {
    this.props.actions.unarchiveExperiment(
      this.props.modals.archiveExperiment.data,
      this.props.context,
      { cToken: this.props.session.experimentCsrfToken }
    );
    this.closeModal();
  }

  // ===================================
  // =           Actions               =
  // ===================================
  closeModal() {
    this.props.actions.closeModal(this.modalName);
  }

  // ===================================
  // =        React Lifecycle          =
  // ===================================
  componentDidUpdate(prevProps) {
    const isOpen = 'modals.archiveExperiment.isOpen';

    if (Util.propChanged(prevProps, this.props, isOpen, true)) {
      this.props.actions.getExperiments();
    }
  }

  // ===================================
  // =           Rendering             =
  // ===================================
  renderFooter() {
    const { formatMessage } = this.props.intl;
    /**
     * Cancel
     */
    const cancelLabel = formatMessage({
      id: 'components.experiment.common.cancel'
    });
    const cancelButton = (
      <Button
        label={cancelLabel}
        variant="neutral"
        onClick={this.closeModal.bind(this)}
      />
    );

    /**
     * Save
     */
    const archiveLabel = formatMessage({
      id: this.getI18nID(
        this.isArchived() ? 'actionButtons.unarchive' : 'actionButtons.archive'
      )
    });
    const archiveButton = (
      <Button
        id="experimentDeleteButton"
        label={archiveLabel}
        variant="brand"
        onClick={
          this.isArchived()
            ? this.handleUnarchive.bind(this)
            : this.handleArchive.bind(this)
        }
      />
    );

    return (
      <div className="footer-button-actions">
        <div className="footer-button-actions-right">
          {cancelButton}
          {archiveButton}
        </div>
      </div>
    );
  }

  renderArchiveExperiment() {
    return (
      <div className="slds-card-wrapper">
        <div className="slds-grid">
          <div className="experiment-description">
            <FormattedMessage
              id={this.getI18nID(
                this.isArchived() ? 'unarchiveDescription' : 'description'
              )}
            />
          </div>
        </div>
      </div>
    );
  }

  renderModal() {
    return this.renderArchiveExperiment();
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen =
      this.props.modals[this.modalName] &&
      this.props.modals[this.modalName].isOpen;
    const modalTitle = formatMessage({
      id: this.getI18nID(this.isArchived() ? 'unarchiveTitle' : 'title')
    });

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        heading={modalTitle}
        footer={this.renderFooter()}
        onRequestClose={this.closeModal.bind(this)}
        dismissOnClickOutside={false}
        isOpen={isOpen || false}
      >
        {this.renderModal()}
      </Modal>
    );
  }
}

ArchiveExperimentModal.propTypes = {
  actions: PropTypes.object.isRequired,
  context: PropTypes.string,
  modals: PropTypes.object.isRequired,
  flags: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  session: PropTypes.object
};

export default injectIntl(ArchiveExperimentModal);
